import { ByteType, FloatType, HalfFloatType, IntType, ShortType, UnsignedByteType, UnsignedInt248Type, UnsignedIntType, UnsignedShort4444Type, UnsignedShort5551Type, UnsignedShortType } from 'three';

export const textureDataTypeValues = {
    UnsignedByteType,
    ByteType,
    ShortType,
    UnsignedShortType,
    IntType,
    UnsignedIntType,
    FloatType,
    HalfFloatType,
    UnsignedShort4444Type,
    UnsignedShort5551Type,
    UnsignedInt248Type,
};

export const textureDataTypeNames: { [v: number]: TextureDataType } = {};
Object.keys(textureDataTypeValues).forEach((k: TextureDataType) =>
{
    textureDataTypeNames[textureDataTypeValues[k]] = k;
});

export type TextureDataType = keyof typeof textureDataTypeValues;
